<template>
  <div>
    <v-alert v-show="true" color="primary" value="true" outline>
      Ces réglages affectent la fonctionnalité meeting (prise de rendez-vous) sur le site <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>. Ses réglages sont indépendants des réglages du "widget".
    </v-alert> 
    <!-- Indique si la licence n'a pas l'option Recall -->
    <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
      {{ $t('warningRecallDisabled') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>

    <!-- Indique si le Callback est déjà activé -->
    <v-alert v-show="alertCallback" color="warning" icon="warning" value="true" outline>
      {{ $t('warningCallbackConflict') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
    </v-alert>
    <div>
      <!-- Chargement -->
      <div v-if="loadingGet" class="text-xs-center">
        <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
      </div>

      <!-- Formulaire -->
      <v-card v-else class="mb-3">
        <v-card-text>
          <v-layout row>
            <v-flex xs12>
              <v-switch 
                :label="onOff ? 'MEETING ON' : 'MEETING OFF'"
                v-model="onOff"
                light
                color="primary"
              ></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      
      <v-flex xs12 md12>
        <v-expansion-panel>
          <!-- STYLE -->
          <v-expansion-panel-content>
            <div slot="header"><v-icon class="primary--text">today</v-icon> {{ $t('priseRdv') }}</div>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 md10>
                      <v-card>
                        <v-card-text>
                          <div slot="header">{{$t('typeRdv')}}</div>
                          <v-radio-group v-model="style" @change="checkConnector" :hint="style == 'RENDEZVOUS' ? 'Targetfirst vous notifie le rendez-vous par email ; le rappel télphonique est effectuée par vos soins.' : 'Vous devez avoir paramétré votre agenda au préalable, avec Vyte ou Google Calendar'" persistent-hint>
                            <v-radio :label="$t('priseRdvTel')" color="primary" value="RENDEZVOUS"></v-radio>
                            <v-radio :label="$t('priseRdvVyte')" color="primary" value="VYTE"></v-radio>
                            <v-radio :label="$t('priseRdvGoogle')" color="primary" value="CALENDAR"></v-radio>
                          </v-radio-group>

                          <v-card>
                            <v-card-text>
                              <div v-if="style === 'VYTE' || style === 'CALENDAR'">
                                <div slot="header"><v-icon class="primary--text">alarm</v-icon> {{$t('dureeRdv')}}</div>
                                <v-layout row>
                                  <v-flex>
                                    <v-slider 
                                      v-model="interRDV"
                                      min="15"
                                      max="120"
                                      step="15"
                                      ticks
                                    ></v-slider>
                                  </v-flex>
                                  <v-flex>
                                    <v-subheader>{{ interRDV }} minutes</v-subheader>
                                  </v-flex>
                                </v-layout>
                                <v-layout row>
                                  <v-flex>
                                    <div slot="header">{{$t('typeForm')}}</div>
                                    <v-radio-group v-model="style2" :hint="style2 == 'REDIRECT' ? 'Un nouvel onglet s\'ouvre dans le navigateur, vers une page dédiée à la prise de rendez-vous' : (style2 == 'DATEPICKER' ? 'La popup de prise de rendez-vous propose directement de cliquer sur la date et l\'heure' : 'La popup de prise de rendez-vous propose des champs de formulaire classiques')" persistent-hint>
                                      <v-radio label="Calendrier visible" color="primary" value="DATEPICKER"></v-radio>
                                      <v-radio v-if="style !== 'CALENDAR'" label="Redirection vers landing page" color="primary" value="REDIRECT"></v-radio>
                                      <v-radio label="Champs classiques" color="primary" value="CDISC"></v-radio>
                                    </v-radio-group>
                                  </v-flex>
                                </v-layout>
                              </div> 
                            </v-card-text>
                          </v-card>

                        </v-card-text>
                      </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>                     
          </v-expansion-panel-content>

          <!-- POPUP -->
          <v-expansion-panel-content v-if="style2 !== 'REDIRECT'">
            <div slot="header"><v-icon class="primary--text">library_add_check</v-icon> Formulaire pop-up</div>
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 md10>
                      <v-card>
                        <v-card-text>
                          <div slot="header">{{$t('modifTitrePopup')}}</div>
                          <v-text-field 
                            v-model="title"
                            data-vv-name="title"
                            :error="wzErrors.has('title')"
                            :error-messages="wzErrors.collect('title')"
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12 md10>
                      <v-card>
                        <v-card-text>
                          <div slot="header">{{$t('modifDesPopup')}}</div>
                          <v-text-field 
                            v-model="msg"
                            data-vv-name="msg"
                            :error="wzErrors.has('msg')"
                            :error-messages="wzErrors.collect('msg')"
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
          </v-expansion-panel-content> 

          <!-- TIRETTE -->
          <v-expansion-panel-content>
            <div slot="header"><v-icon class="primary--text">account_balance_wallet</v-icon> Tirette</div>
            <v-card>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 md10>
                    <v-card>
                      <v-card-text>
                        <div slot="header">{{$t('choixIconeTirette')}}</div>
                        <v-card>
                          <v-card-text>
                            <v-container grid-list-sm fluid>
                              <v-layout row wrap v-if="pictoTirette.length">
                                <v-flex
                                  v-for="(img, i) in pictoTirette"
                                  :key="i"
                                >
                                  <v-hover>
                                    <v-card
                                      flat
                                      tile
                                      class="d-flex tf-picto-recall"
                                      @click="updateImg(img, i)"
                                      style="cursor: pointer;"
                                      slot-scope="{ hover }"
                                      :class="`elevation-${hover ? 6 : 0}`"
                                      :style="choixIcone === i ? 'border: 1px solid red' : ''"
                                      :id="'picto_' + i"
                                    >
                                      <v-img :src="img">
                                        <v-layout
                                          slot="placeholder"
                                          align-center
                                          justify-center
                                        >
                                          <v-progress-circular
                                            indeterminate
                                            color="grey lighten-5"
                                          ></v-progress-circular>
                                        </v-layout>
                                      </v-img>
                                    </v-card>
                                  </v-hover>
                                </v-flex>
                              </v-layout>
                              <v-progress-circular
                                v-else
                                indeterminate
                                color="primary"
                              ></v-progress-circular>
                            </v-container>
                          </v-card-text>
                        </v-card>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12 md10>
                    <v-card>
                      <v-card-text>
                        <div slot="header">{{$t('screenSide')}}</div>
                        <v-radio-group v-model="side">
                          <v-radio label="Côté gauche" color="primary" value="LEFT"></v-radio>
                          <v-radio label="Côté droit" color="primary" value="RIGHT"></v-radio>
                        </v-radio-group>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex>
                  <v-card>
                    <v-card-text>
                    
                      <div slot="header"><v-icon class="primary--text">alarm</v-icon> {{$t('delaiTiretteC2C')}}</div>
                        <v-layout row>
                          <v-flex>
                            <v-slider 
                              v-model="timeout"
                              :min="0"
                              :max="300"
                            ></v-slider>
                          </v-flex>
                          <v-flex>
                            <v-subheader>{{ timeout }} sec.</v-subheader>
                          </v-flex>
                        </v-layout>
                      
                    </v-card-text>
                  </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <!-- HORAIRES -->
          <v-expansion-panel-content>
            <div slot="header"><v-icon class="primary--text">schedule</v-icon> 
            {{$t('restrictAff')}}
            <v-tooltip left
              @click.native.stop="openDialog(
                {
                  title: 'Visualiser et activer le Meeting',
                  content: 'Les horaires ci-paramétrés régissent la visualisation de la tirette (Click To Action). En dehors des heures éligibles, la tirette ne sera pas visible. Les règles d\'affichage du widget (1ère section à gauche) n\'influencent pas la tirette.'
                }
              )"
            >
              <template slot="activator">
                <v-icon class="infos" color="grey lighten-1" dark>info</v-icon>
              </template>
              <span>{{$t('enSavoirPlus')}}</span>
            </v-tooltip>
			</div>
            <v-card class="mb-3">
              <v-card-text>
                <v-card class="mb-3">
                  <v-card-text>
                    <div slot="header">{{ $t("displayTimes") | cap }}</div>
                    <v-layout>
                      <v-flex xs12 sm12 md6>
                        <!-- Horaires d'affichage -->
                        <v-radio-group v-model="form.hours" :hint="$t('defineWidgetHours')" persistent-hint>
                          <v-radio :label="$t('allTheTime') | cap" color="primary" value="all"></v-radio>
                          <v-radio :label="$t('customHours')  | cap" color="primary" value="defined"></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                    <!-- Définition des horaires -->
                    <v-layout v-if="form.hours == 'defined'" row wrap>
                      <v-flex xs12>
                        <v-btn flat class="primary--text" @click="openHours()">{{ $t('timesSeveralDays') }}<v-icon right>event</v-icon></v-btn>
                      </v-flex>
                      <v-expansion-panel>
                        <v-expansion-panel-content v-for="day in form.days" :key="day.name">
                          <v-layout align-center row spacer slot="header">
                            <v-flex xs12>
                              <span class="hidden-md-and-up">{{ day.name.substring(0, 3) }}. : </span>
                              <span class="hidden-sm-and-down">{{ day.name }} : </span>
                              <span v-if="day.am.active || day.pm.active">
                                <span v-if="day.am.active"> {{ $t('from') }}<code>{{ day.am.start }}</code> {{ $t('to') }} <code>{{ day.am.end }}</code></span>
                                <span v-if="day.am.active && day.pm.active"> {{ $t('and') }}</span>
                                <span v-if="day.pm.active">{{ $t('from') }} <code>{{ day.pm.start }}</code> {{ $t('to') }} <code>{{ day.pm.end }}</code></span>
                              </span>
                              <span v-else>
                                <span>{{ $t("disabledToday") | cap }}</span>
                              </span>
                            </v-flex>
                          </v-layout>
                          <v-card class="grey lighten-3">
                            <v-card-text>
                              <v-layout row wrap>
                                <v-flex xs12 sm6 md2>
                                  <!-- Activer le matin -->
                                  <v-switch 
                                    :label="$t('activateMorning') | cap " 
                                    v-model="day.am.active"
                                    light
                                    color="primary"
                                  ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <!-- Temps Matin -->
                                  <v-text-field 
                                    slot="activator"
                                    :label="$t('from') + ` ${ day.name } ` + $t('morning')"
                                    v-model="day.am.start"
                                    prepend-icon="access_time"
                                    :disabled="!day.am.active"
                                    readonly
                                    @click="openTimePicker(day, 'am', 'start')"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-text-field 
                                    slot="activator"
                                    :label="$t('to') + ` ${ day.name } ` + $t('morning')"
                                    v-model="day.am.end"
                                    prepend-icon="access_time"
                                    :disabled="!day.am.active"
                                    readonly
                                    @click="openTimePicker(day, 'am', 'end')"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout row wrap>
                                <v-flex xs12 sm6 md2>
                                  <!-- Activer l'après-midi -->
                                  <v-switch 
                                    :label="$t('activateAfternoon') | cap " 
                                    v-model="day.pm.active"
                                    light
                                    color="primary"
                                  ></v-switch>
                                </v-flex>
                                <!-- Temps Après-midi -->
                                <v-flex xs12 sm6 md2>
                                  <v-text-field 
                                    slot="activator"
                                    :label="$t('from') + ` ${ day.name } ` + $t('afternoon')"
                                    v-model="day.pm.start"
                                    prepend-icon="access_time"
                                    :disabled="!day.pm.active"
                                    readonly
                                    @click="openTimePicker(day, 'pm', 'start')"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md2>
                                  <v-text-field 
                                    slot="activator"
                                    :label="$t('to') + ` ${ day.name } ` + $t('afternoon')"
                                    v-model="day.pm.end"
                                    prepend-icon="access_time"
                                    :disabled="!day.pm.active"
                                    readonly
                                    @click="openTimePicker(day, 'pm', 'end')"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>

          <!-- BLACK LISTS -->
          <v-expansion-panel-content>
            <div slot="header"><v-icon class="mr-2 primary--text">language</v-icon>
              {{ $t('urlDisplay') | cap }}
              <v-tooltip left
                @click.native.stop="openDialog(
                  {
                    title: 'Visualiser et activer le Meeting',
                    content: 'Les listes ci-paramétrées régissent la visualisation de la tirette (Click To Action). En dehors des pages éligibles, la tirette ne sera pas visible. Les règles d\'affichage du widget (1ère section à gauche) n\'influencent pas la tirette.'
                  }
                )"
              >
                <template slot="activator">
                  <v-icon class="infos" color="grey lighten-1" dark>info</v-icon>
                </template>
                <span>{{$t('enSavoirPlus')}}</span>
              </v-tooltip>
            </div>
            <v-card>
              <v-card-text>
                <v-card class="mb-3">
                  <v-card-text>
                    <div slot="header">{{ $t('urlDisplay') | cap }}</div>
                    <v-layout>
                      <v-flex xs12 md6>
                        <v-radio-group v-model="form.urls" :hint="$t('chooseWhiteOrBlackC2C')" persistent-hint>
                          <v-radio :label="$t('everywhere') | cap " color="primary" value="all"></v-radio>
                          <v-radio label="White List" color="primary" value="showOnOff"></v-radio>
                          <v-radio label="Black List" color="primary" value="hideOnOff"></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  
                    <v-layout wrap v-show="form.urls != 'all'">
                      <v-flex xs12>
                        <v-card>
                          <v-card-text>
                              <v-fab-transition slot="activator">
                                <v-btn
                                  v-show="form.urls != 'all'"
                                  class="secondary"
                                  dark
                                  absolute
                                  top
                                  right
                                  fab
                                  @click.stop="openRule()"
                                >
                                  <v-icon>add</v-icon>
                                </v-btn>
                              </v-fab-transition>
                            <v-data-table
                              :headers="headersRules"
                              :items="form.rules"
                              :no-data-text="$t('noRules')"
                              hide-actions
                            >
                              <template slot="items" slot-scope="props">
                                <td v-if="props.item.list === form.urls">
                                  <v-edit-dialog
                                    :return-value.sync="props.item.type"
                                    :cancel-text="$t('cancel')"
                                    :save-text="$t('submit')"
                                    large
                                  >
                                    <div>{{ props.item.type.text }}</div>
                                    <div slot="input" class="mt-3 title">{{ $t('changeType') }}</div>
                                    <v-select
                                      slot="input"
                                      :items="typeRules"
                                      v-model="props.item.type"
                                      return-object
                                      autofocus
                                    ></v-select>
                                  </v-edit-dialog>
                                </td>
                                <td v-if="props.item.list === form.urls">
                                  <v-edit-dialog
                                    :cancel-text="$t('cancel')"
                                    :save-text="$t('submit')"
                                    :return-value.sync="props.item.content"
                                    large
                                    lazy
                                  >
                                    <div><code>{{ props.item.content }}</code></div>
                                    <div slot="input" class="mt-3 title">{{ $t('editContent') }}</div>
                                    <v-text-field
                                      slot="input"
                                      label="Modification"
                                      v-model="props.item.content"
                                      single-line
                                      counter
                                      autofocus
                                    ></v-text-field>
                                  </v-edit-dialog>
                                </td>
                                <td v-if="props.item.list === form.urls" class="text-xs-right">
                                  <v-btn icon flat @click.stop="deleteRule(props.index)">
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </td>
                              </template>
                            </v-data-table>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
          
          <!-- RESTRICTION -->
          <v-expansion-panel-content>
            <div slot="header"><v-icon class="mr-2 primary--text">app_blocking</v-icon>
              Restrictions mobiles
              <v-tooltip left
                @click.native.stop="openDialog(
                  {
                    title: 'Visualiser et activer le Meeting',
                    content: 'Masquer sur mobile indépendamment des règles horaires et de blacklist'
                  }
                )"
              >
                <template slot="activator">
                  <v-icon class="infos" color="grey lighten-1" dark>info</v-icon>
                </template>
                <span>{{$t('enSavoirPlus')}}</span>
              </v-tooltip>
            </div>
            <v-card row wrap>
              <v-flex xs12>
                <!-- Masquer sur mobile -->
                <v-switch 
                  :label="$t('hideOnMobile') | cap" 
                  v-model="hiddenMobile"
                  light
                  color="primary"
                ></v-switch>
              </v-flex>
            </v-card>
          </v-expansion-panel-content>

        </v-expansion-panel>
      </v-flex>
<!--
      <v-flex xs12 md6>
        <v-card height="550px">
          <iframe
            width="100%"
            height="550"
            :src="iframePreviewMeeting"
            frameborder="0"
          ></iframe>
        </v-card>
      </v-flex>
-->
      <!-- Validation du formulaire -->
      <div class="text-xs-right">
        <v-btn
          color="primary"
          :block="$vuetify.breakpoint.xsOnly"
          :loading="loadingPost"
          @click.native="postOptions()"
          :disabled="alert"
        >{{ $t('save') | cap }}<v-icon dark right>save</v-icon>
        </v-btn>
      </div>

      <!-- dialog Infos -->
      <wz-dialog-infos
        @fermeDialog="fermeDialogInfos"
        :titleDialog="titleDialog"
        :contentDialog="contentDialog"
      >
      </wz-dialog-infos>

      <!-- Time picker -->
      <v-dialog persistent v-model="showTp" lazy max-width="290">
        <v-time-picker 
          v-model="daySelected[amOrPm][startOrEnd]"
          actions
          scrollable
          format="24hr"
          :max="allowed.hours.max"
          :min="allowed.hours.min"
          color="primary"
        >
          <v-spacer></v-spacer>
          <v-btn flat @click="showTp = false; daySelected[amOrPm][startOrEnd] = tmpHours">{{ $t('cancel') | cap }}</v-btn>
          <v-btn flat color="primary" @click="showTp = false">{{ $t('submit') | cap }}</v-btn>
        </v-time-picker>
      </v-dialog>
      
      <!-- Appliquer les horaires d'une journée -->
      <v-dialog v-model="showHours" scrollable persistent width="350px">
        <v-card>
          <v-card-title class="primary white--text">{{ $t('applySchedules') | cap }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="height: 400px;">
            <v-select
              :items="days"
              v-model="dayHours"
              :label="$t('applyHours')" 
              return-object
            ></v-select>
            <v-data-table
              :headers="headersDays"
              :items="days"
              v-model="daysTmp"
              item-key="text"
              select-all="primary"
              class="elevation-1"
              hide-actions
              :total-items="7"
            >
              <template slot="headerCell" slot-scope="props">
                <span class="subheading">{{ props.header.text }}</span>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    hide-details
                    class="primary--text"
                    v-model="props.selected"
                  ></v-checkbox>
                </td>
                <td>{{ props.item.text }}</td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showHours = false">{{ $t('cancel') }}</v-btn>
            <v-btn :disabled="!daysTmp.length" color="primary" flat @click="submitHours()">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- DIALOGUE Création règle-->
      <v-dialog v-model="showDialogRule" persistent max-width="290">
        <v-card>
          <v-card-title class="primary white--text">{{ $t("createRule") | cap }}</v-card-title>
          <v-card-text>
            <form>
              <v-select
                v-model="ruleTmp.type"
                :items="typeRules"
                :label="$t('ruleType')"  
                return-object
                required
                v-validate="'required'" 
                data-vv-name="select"
                :error="wzErrors.has('select')"
                :error-messages="wzErrors.collect('select')"
              ></v-select>
              <v-text-field
                autofocus
                v-model="ruleTmp.content"
                :label="$t('ruleContent')" 
                required
                v-validate="'required'" 
                data-vv-name="ruleContentInput"
                :error="wzErrors.has('ruleContentInput')"
                :error-messages="wzErrors.collect('ruleContentInput')"
                @keyup.native.enter="submitRule()"
              ></v-text-field>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="showDialogRule = false">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" :disabled="wzErrors.any()" flat @click="submitRule()">{{ $t('submit') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog connecteur vyte -->
      <v-dialog v-model="displayWarningVyte" max-width="290">
        <v-card>
          <v-card-title class="primary white--text subheading">{{$t('warning')}}</v-card-title>
          <v-card-text>
            {{$t('vyteDesc')}}
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              class="primary--text"
              flat
              @click="goToConnector()"
            >
              {{$t('paramConnecteur')}}
              <v-icon right>refresh</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>    
	  <!-- dialog connecteur calendar -->
      <v-dialog v-model="displayWarningCalendar" max-width="290">
        <v-card>
          <v-card-title class="primary white--text subheading">{{$t('warning')}}</v-card-title>
          <v-card-text>
            {{$t('googleAgendaDesc')}}
          </v-card-text>
          <v-card-actions>
            <v-btn
              block
              class="primary--text"
              flat
              @click="goToConnector()"
            >
              {{$t('paramConnecteur')}}
              <v-icon right>refresh</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- dialog progress bar installation -->
    <wz-dialog-progress
      @fermeDialogProgress="fermeDialogProgress"
      :dialogProgress="dialogProgress"
      :etape=6
    >
    </wz-dialog-progress>
  </div>
</template>

<script>
import _ from 'lodash'
import { DOMAINE, RECALL_DIR } from '../../constants'
export default {
  data () {
    return {
      alert: false,
      alertCallback: false,
      titleDialog: '',
      contentDialog: '',
      onOff: false,
      options: {},
      style: 'RENDEZVOUS',
      timeout: 0,
      title: 'Meeting',
      msg: 'Entrez les détails',
      img: '',
      interRDV: 30,
      style2: 'DATEPICKER',
      side: 'RIGHT',
      choixIcone: 0,
      hiddenMobile: false,
      pictoTirette: [],
      vymail: '',
      connecteurVyte: '0',
      displayWarningVyte: 0,
      displayWarningCalendar: 0,
      form: {
        // horaires d'affichage
        hours: '',
        days: [
          {
            name: this.$t('monday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('tuesday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('wednesday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('thursday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('friday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('saturday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          },
          {
            name: this.$t('sunday'),
            am: { start: '08:00', end: '12:00', active: true },
            pm: { start: '14:00', end: '18:00', active: true }
          }
        ],
        // URLs d'affichage
        urls: '',
        rules: []
      },
      // time pickers
      showTp: false,
      daySelected: {},
      tmpHours: null,
      amOrPm: 'am',
      startOrEnd: 'start',
      allowed: { hours: { min: '0:00', max: '12:00' } },
      dependency: '',

      // dialog appliquer les horaires
      showHours: false,
      daysTmp: [],
      dayHours: null,
      days: [
        { text: _.upperFirst(this.$t('monday')), value: 0 },
        { text: _.upperFirst(this.$t('tuesday')), value: 1 },
        { text: _.upperFirst(this.$t('wednesday')), value: 2 },
        { text: _.upperFirst(this.$t('thursday')), value: 3 },
        { text: _.upperFirst(this.$t('friday')), value: 4 },
        { text: _.upperFirst(this.$t('saturday')), value: 5 },
        { text: _.upperFirst(this.$t('sunday')), value: 6 }
      ],
      // URLs d'affichage
      tmp: '',
      headersRules: [
        { text: _.upperFirst(this.$t('type')), align: 'left', sortable: false, value: 'type' },
        { text: _.upperFirst(this.$t('content')), align: 'left', sortable: false, value: 'content' },
        { text: '', align: 'left', sortable: false, value: 'actions' }
      ],
      typeRules: [
        { text: _.upperFirst(this.$t('fullUrl')), value: 'DSK_SHOW_URL' },
        { text: _.upperFirst(this.$t('containedUrl')), value: 'DSK_SHOW_PART_URL' },
        { text: _.upperFirst(this.$t('keyWords')), value: 'DSK_SHOW_TAGS' },
        { text: _.upperFirst(this.$t('classOrId')), value: 'DSK_SHOW_CLASS_ID' }
      ],
      showDialogRule: false,
      ruleTmp: {content: '', type: {}},
      // loaders
      loadingGet: false,
      loadingPost: false,
      dialogProgress: false
    }
  },

  mounted () {
    this.getOptions()
    this.loadImg()
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress()
    }
  },

  created () {
    this.daySelected = this.form.days[0]
    this.dayHours = { text: this.form.days[0].name, value: 0 }
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_recall'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_recall'
        }
      }, 800);
    }
    /* eslint-enable */
  },

  computed: {
    headersDays () {
      return !this.daysTmp.length
      ? [{text: this.$t('allDays'), align: 'left', sortable: false}]
      : [{text: this.$t('noDays'), align: 'left', sortable: false}]
    },
    /**
     * @return {String} URL de l'iframe représentant le meeting
     */
    iframePreviewMeeting () {
      return (process.env.NODE_ENV === 'development')
      ? `${DOMAINE}/dev/fo/incl/inner2019.php?${this.iframeParams}`
      : `${DOMAINE}/fo/incl/inner2019.php?${this.iframeParams}`
    },
    /**
     * @return {String} paramètres des iframes
     */
    iframeParams () {
      // console.log('this.options', this.options)
      // const lang = this.options.DSK_GETELANG === 0
      //  ? this.$i18n.locale.toUpperCase()
      //  : this.options.DSK_GETELANG
      // const titleMiddleState = this.options.DSK_TAB_MSG_JSON[lang]
      // const titleMiddleState2 = this.options.DSK_TAB_MSG_JSON2[lang]
      //  const titleMiddleState3 = this.options.DSK_TAB_MSG_JSON3[lang]
      let params = ``
      // let params = `deskColors=${this.colorsToString}`
      // params = `${params}&deskWidth=${this.options.DSK_WIDTH}`
      // params += `&deskHeight=${this.options.DSK_HEIGHT}`
      // params += `&deskOnline=${this.widgetOnline}`
      // params += `&callbackOnOff=${this.options.DSK_CALLBACK_ONOFF}`
      // params += `&deskOngletRadius=${Array(4).fill(this.radius).join('|')}`
      // params += `&fullName=${this.$store.getters['_User/fullName']}`
      // params += `&job=${this.$store.state._User.job}`
      // params += `&avatarId=${this.$store.state._User.id}`
      // params += `&side=${this.options.DSK_TAB_SIDE}`
      // params += `&pos=${this.options.DSK_TAB_POS}`
      // params += `&sideOn=${this.options.DSK_SIDEON}`
      // params += `&sideHover=${this.options.DSK_SIDEHOVER}`
      // params += `&state=${this.activeState2019 + 1}`
      // params += `&hideAgents=${this.options.DSK_HIDE_AGENT_LIST}`
      // params += `&hideMiddleState=${this.options.DSK_HIDE_MIDDLE_STATE}`
      // params += `&lang=${this.options.DSK_GETELANG}`
      // params += `&imgMiddleState=${this.lastImg}`
      // params += `&titleMiddleState=${titleMiddleState}`
      // params += `&titleMiddleState2=${titleMiddleState2}`
      // params += `&titleMiddleState3=${titleMiddleState3}`
      return params
    }
  },

  methods: {
    openTimePicker (day, amOrPm, startOrEnd) {
      this.showTp = true // ouverture du dialog
      this.daySelected = day
      this.amOrPm = amOrPm
      this.startOrEnd = startOrEnd
      this.tmpHours = this.daySelected[amOrPm][startOrEnd]
      // heures et minutes autorisées dans le time pîcker
      this.allowed.hours = amOrPm === 'am'
      ? { min: '0:00', max: '12:59' } // matin
      : { min: '12:00', max: '23:59' } // aprem
    },

    /**
     * Gestion de l'application d'horaires à plusieurs jours
     */
    openHours () {
      this.showHours = true
    },
    submitHours () {
      this.showHours = false
      // pour tous les jours sélectionnés
      // il faut changer leurs horaires
      // par ceux du jour sélectionné
      const daySelected = this.form.days.find(d => d.name === this.dayHours.text)
      this.daysTmp.forEach(day => {
        let d = this.form.days.find(d => d.name === day.text.toLowerCase())
        d.am = _.cloneDeep(daySelected.am)
        d.pm = _.cloneDeep(daySelected.pm)
      })
      this.daysTmp = []
    },
    /**
     * Gestion des urls
     */
    openRule () {
      this.showDialogRule = true
      this.ruleTmp = { content: '', type: this.typeRules[0], list: this.form.urls }
    },
    submitRule () {
      if (!_.isEmpty(this.ruleTmp.content)) {
        this.showDialogRule = false
        this.form.rules.push(_.clone(this.ruleTmp))
      } else {
        this.$validator.validateAll()
      }
    },
    deleteRule (index) {
      this.form.rules.splice(index, 1)
    },
    getOptions () {
      if (
        this.$store.state._Sites.siteSelected.LIC_RECALL_ACTIVATED !== '1'
      ) {
        this.alert = true
        return
      }
      if (
        this.$store.state._Sites.siteSelected.DSK_CALLBACK_ONOFF === '1'
      ) {
        this.alertCallback = true
      }
      this.alert = false
      this.loadingGet = true
      this.axios
        .get(
          'get/settings_recall.php?desk=' +
            this.$store.state._Sites.siteSelected.LIC_DSK_ID
        )
        .then(response => {
          this.onOff = response.data.DSK_RECALL_ONOFF === '1'
          this.timeout = response.data.DSK_RECALL_DELAY
          this.style = response.data.DSK_RECALL_STYLE
          if (response.data.DSK_RECALL_TITLE !== '') {
            this.title = response.data.DSK_RECALL_TITLE
          }
          if (response.data.DSK_RECALL_MSG !== '') {
            this.msg = response.data.DSK_RECALL_MSG
          }
          this.img = response.data.DSK_RECALL_IMG
          this.dependency = response.data.DSK_RECALL_DEPENDANT
          this.hiddenMobile = (response.data.DSK_RECALL_HIDE_MOBILE === '1')
          this.choixIcone = parseInt(response.data.DSK_RECALL_PICTO) /* 0,1,2,3 */
          this.interRDV = parseInt(response.data.DSK_RECALL_DURATION) /* 15,30,...,120 */
          this.style2 = response.data.DSK_RECALL_STYLE2 /* DATEPICKER REDIRECT CDISC */
          this.side = response.data.DSK_RECALL_SIDE /* RIGHT LEFT */
          this.vymail = response.data.DSK_RECALL_VYMAIL /* RIGHT LEFT */
          this.connecteurVyte = response.data.CONNECTOR_VYMAIL
          this.connecteurCalendar = response.data.CONNECTOR_CALENDAR
          // options URL
          this.form.urls = 'all'
          if (response.data.DSK_RECALL_SHOW_ONOFF === '1') {
            this.form.urls = 'showOnOff'
          } else if (response.data.DSK_RECALL_HIDE_ONOFF === '1') {
            this.form.urls = 'hideOnOff'
          }
          this.form.rules = []
          // urls white list
          _.each(response.data.DSK_RECALL_SHOW_URL.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[0]), 'list': 'showOnOff' })
          })
          _.each(response.data.DSK_RECALL_SHOW_PART_URL.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[1]), 'list': 'showOnOff' })
          })
          _.each(response.data.DSK_RECALL_SHOW_TAGS.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[2]), 'list': 'showOnOff' })
          })
          _.each(response.data.DSK_RECALL_SHOW_CLASS_ID.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[3]), 'list': 'showOnOff' })
          })
          // urls black list
          _.each(response.data.DSK_RECALL_HIDE_URL.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[0]), 'list': 'hideOnOff' })
          })
          _.each(response.data.DSK_RECALL_HIDE_PART_URL.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[1]), 'list': 'hideOnOff' })
          })
          _.each(response.data.DSK_RECALL_HIDE_TAGS.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[2]), 'list': 'hideOnOff' })
          })
          _.each(response.data.DSK_RECALL_HIDE_CLASS_ID.split('|'), url => {
            if (!_.isEmpty(url)) this.form.rules.push({ content: url, type: _.clone(this.typeRules[3]), 'list': 'hideOnOff' })
          })

          // options horaires
          this.form.hours = response.data.DSK_SCHEDULES_RECALL.split('|')[0]
          let hours = response.data.DSK_SCHEDULES_RECALL.split('|')
          // lundi
          this.form.days[0].am.active = !_.isEmpty(hours[1] + hours[2] + hours[3] + hours[4]) && !_.isNil(hours[1]) && !_.isNil(hours[2]) && !_.isNil(hours[3]) && !_.isNil(hours[4])
          this.form.days[0].am.start = (this.form.days[0].am.active) ? hours[1] + ':' + hours[2] : '00:00'
          this.form.days[0].am.end = (this.form.days[0].am.active) ? hours[3] + ':' + hours[4] : '00:00'
          this.form.days[0].pm.active = !_.isEmpty(hours[5] + hours[6] + hours[7] + hours[8])
          this.form.days[0].pm.start = (this.form.days[0].pm.active) ? hours[5] + ':' + hours[6] : '12:00'
          this.form.days[0].pm.end = (this.form.days[0].pm.active) ? hours[7] + ':' + hours[8] : '12:00'
          // mardi
          this.form.days[1].am.active = !_.isEmpty(hours[9] + hours[10] + hours[11] + hours[12])
          this.form.days[1].am.start = (this.form.days[1].am.active) ? hours[9] + ':' + hours[10] : '00:00'
          this.form.days[1].am.end = (this.form.days[1].am.active) ? hours[11] + ':' + hours[12] : '00:00'
          this.form.days[1].pm.active = !_.isEmpty(hours[13] + hours[14] + hours[15] + hours[16])
          this.form.days[1].pm.start = (this.form.days[1].am.active) ? hours[13] + ':' + hours[14] : '12:00'
          this.form.days[1].pm.end = (this.form.days[1].am.active) ? hours[15] + ':' + hours[16] : '12:00'
          // mercredi
          this.form.days[2].am.active = !_.isEmpty(hours[17] + hours[18] + hours[19] + hours[20])
          this.form.days[2].am.start = (this.form.days[2].am.active) ? hours[17] + ':' + hours[18] : '00:00'
          this.form.days[2].am.end = (this.form.days[2].am.active) ? hours[19] + ':' + hours[20] : '00:00'
          this.form.days[2].pm.active = !_.isEmpty(hours[21] + hours[22] + hours[23] + hours[24])
          this.form.days[2].pm.start = (this.form.days[2].pm.active) ? hours[21] + ':' + hours[22] : '12:00'
          this.form.days[2].pm.end = (this.form.days[2].pm.active) ? hours[23] + ':' + hours[24] : '12:00'
          // jeudi
          this.form.days[3].am.active = !_.isEmpty(hours[25] + hours[26] + hours[27] + hours[28])
          this.form.days[3].am.start = (this.form.days[3].am.active) ? hours[25] + ':' + hours[26] : '00:00'
          this.form.days[3].am.end = (this.form.days[3].am.active) ? hours[27] + ':' + hours[28] : '00:00'
          this.form.days[3].pm.active = !_.isEmpty(hours[29] + hours[30] + hours[31] + hours[32])
          this.form.days[3].pm.start = (this.form.days[3].pm.active) ? hours[29] + ':' + hours[30] : '12:00'
          this.form.days[3].pm.end = (this.form.days[3].pm.active) ? hours[31] + ':' + hours[32] : '12:00'
          // vendredi
          this.form.days[4].am.active = !_.isEmpty(hours[33] + hours[34] + hours[35] + hours[36])
          this.form.days[4].am.start = (this.form.days[4].am.active) ? hours[33] + ':' + hours[34] : '00:00'
          this.form.days[4].am.end = (this.form.days[4].am.active) ? hours[35] + ':' + hours[36] : '00:00'
          this.form.days[4].pm.active = !_.isEmpty(hours[37] + hours[38] + hours[39] + hours[40])
          this.form.days[4].pm.start = (this.form.days[4].pm.active) ? hours[37] + ':' + hours[38] : '12:00'
          this.form.days[4].pm.end = (this.form.days[4].pm.active) ? hours[39] + ':' + hours[40] : '12:00'
          // samedi
          this.form.days[5].am.active = !_.isEmpty(hours[41] + hours[42] + hours[43] + hours[44])
          this.form.days[5].am.start = (this.form.days[5].am.active) ? hours[41] + ':' + hours[42] : '00:00'
          this.form.days[5].am.end = (this.form.days[5].am.active) ? hours[43] + ':' + hours[44] : '00:00'
          this.form.days[5].pm.active = !_.isEmpty(hours[45] + hours[46] + hours[47] + hours[48])
          this.form.days[5].pm.start = (this.form.days[5].pm.active) ? hours[45] + ':' + hours[46] : '12:00'
          this.form.days[5].pm.end = (this.form.days[5].pm.active) ? hours[47] + ':' + hours[48] : '12:00'
          // dimanche
          this.form.days[6].am.active = !_.isEmpty(hours[49] + hours[50] + hours[51] + hours[52])
          this.form.days[6].am.start = (this.form.days[6].am.active) ? hours[49] + ':' + hours[50] : '00:00'
          this.form.days[6].am.end = (this.form.days[6].am.active) ? hours[51] + ':' + hours[52] : '00:00'
          this.form.days[6].pm.active = !_.isEmpty(hours[53] + hours[54] + hours[55] + hours[56])
          this.form.days[6].pm.start = (this.form.days[6].pm.active) ? hours[53] + ':' + hours[54] : '12:00'
          this.form.days[6].pm.end = (this.form.days[6].pm.active) ? hours[55] + ':' + hours[56] : '12:00'

          this.checkConnector()
        })
        .catch(_ => {})
        .then(_ => {
          this.loadingGet = false
        })
    },

    postOptions () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()

      dataToPost.append(
        'DSK_ID',
        this.$store.state._Sites.siteSelected.LIC_DSK_ID
      )
      dataToPost.append(
        'LIC_KEY',
        this.$store.state._Sites.siteSelected.LIC_KEY
      )
      dataToPost.append('DSK_RECALL_ONOFF', this.onOff ? '1' : '0')
      dataToPost.append('DSK_RECALL_DELAY', this.timeout)
      dataToPost.append('DSK_RECALL_STYLE', this.style)
      dataToPost.append('DSK_RECALL_TITLE', this.title)
      dataToPost.append('DSK_RECALL_MSG', this.msg)
      dataToPost.append('DSK_RECALL_IMG', this.img)
      dataToPost.append('DSK_RECALL_DEPENDANT', this.dependency)
      dataToPost.append('DSK_RECALL_HIDE_MOBILE', this.hiddenMobile ? '1' : '0')
      dataToPost.append('DSK_RECALL_PICTO', this.choixIcone)
      dataToPost.append('DSK_RECALL_DURATION', this.interRDV)
      dataToPost.append('DSK_RECALL_STYLE2', this.style2)
      dataToPost.append('DSK_RECALL_SIDE', this.side)
      dataToPost.append('DSK_RECALL_VYMAIL', this.vymail)

      // options URLs
      dataToPost.append('DSK_RECALL_HIDE_ONOFF', (this.form.urls === 'hideOnOff') ? '1' : '0')
      dataToPost.append('DSK_RECALL_SHOW_ONOFF', (this.form.urls === 'showOnOff') ? '1' : '0')
      let url = {'showOnOff': '', hideOnOff: ''}
      let partUrl = {'showOnOff': '', hideOnOff: ''}
      let tags = {'showOnOff': '', hideOnOff: ''}
      let classId = {'showOnOff': '', hideOnOff: ''}
      _.each(this.form.rules, rule => {
        if (this.typeRules[0].value === rule.type.value) {
          url[rule.list] += rule.content + '|'
        } else if (this.typeRules[1].value === rule.type.value) {
          partUrl[rule.list] += rule.content + '|'
        } else if (this.typeRules[2].value === rule.type.value) {
          tags[rule.list] += rule.content + '|'
        } else if (this.typeRules[3].value === rule.type.value) {
          classId[rule.list] += rule.content + '|'
        }
      })
      dataToPost.append('DSK_RECALL_SHOW_URL', url.showOnOff)
      dataToPost.append('DSK_RECALL_SHOW_PART_URL', partUrl.showOnOff)
      dataToPost.append('DSK_RECALL_SHOW_TAGS', tags.showOnOff)
      dataToPost.append('DSK_RECALL_SHOW_CLASS_ID', classId.showOnOff)
      dataToPost.append('DSK_RECALL_HIDE_URL', url.hideOnOff)
      dataToPost.append('DSK_RECALL_HIDE_PART_URL', partUrl.hideOnOff)
      dataToPost.append('DSK_RECALL_HIDE_TAGS', tags.hideOnOff)
      dataToPost.append('DSK_RECALL_HIDE_CLASS_ID', classId.hideOnOff)

      // options horaires
      let hours = this.form.hours
      _.each(this.form.days, day => {
        hours += (day.am.active) // si Watcheezy actif le matin
        ? '|' + day.am.start.split(':')[0] + '|' + day.am.start.split(':')[1] + '|' + day.am.end.split(':')[0] + '|' + day.am.end.split(':')[1]
        : '||||'
        hours += (day.pm.active) // si Watcheezy actif l'aprem
        ? '|' + day.pm.start.split(':')[0] + '|' + day.pm.start.split(':')[1] + '|' + day.pm.end.split(':')[0] + '|' + day.pm.end.split(':')[1]
        : '||||'
      })
      dataToPost.append('DSK_SCHEDULES_RECALL', hours)
      this.loadingPost = true
      this.axios
        .post('post/settings_recall.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.$store.state._Sites.siteSelected.DSK_RECALL_ONOFF = this.onOff ? '1' : '0'
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loadingPost = false
        })
    },
    loadImg () {
      this.axios.get('get/imagesPicto.php').then((res) => {
        this.pictoTirette = res.data.map(img => RECALL_DIR + img)
      })
    },
    updateImg (img, elt) {
      img = img.split('/').reverse()[0].split('.')[0]
      this.choixIcone = img
      let allpicto = document.querySelectorAll('.picto')
      for (let j = 0; j < allpicto.length; j++) {
        allpicto[j].style.border = ''
      }
      document.getElementById('picto_' + elt).style.border = '1px solid black'
    },
    checkConnector () {
      if (this.connecteurVyte === '0' && this.style === 'VYTE') {
        this.displayWarningVyte = 1
      } else {
        this.displayWarningVyte = 0
      }

      if (this.connecteurCalendar === '0' && this.style === 'CALENDAR') {
        this.displayWarningCalendar = 1
      } else {
        this.displayWarningCalendar = 0
      }
    },
    goToConnector () {
      this.$router.push({ path: '/settings/connectors' })
    },
    // ---------------------------
    // open dialog Infos
    openDialog (data) {
      this.titleDialog = data.title
      this.contentDialog = data.content
    },
    // ---------------------------
    // close dialog Infos
    fermeDialogInfos () {
      this.titleDialog = ''
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function (v) {
      this.getOptions()
    }
  }
}
</script>

<style>
.tf-picto-recall {
  height: 50px;
  width: 45px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/Recall.vue